import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Crown, Sparkles, ChevronRight } from 'lucide-react';

const CATEGORIES = [
  {
    id: 'prime',
    name: 'Novità Server Prime',
    desc: 'Nuovi film e serie TV pubblicati sul Server Prime',
    dot: 'bg-[var(--gold)]',
    ring: 'from-[var(--gold)]/30 to-transparent',
    border: 'border-[var(--gold)]/40',
    icon: Crown,
    accent: 'text-[var(--gold)]',
  },
  {
    id: 'elite',
    name: 'Novità Server Elite',
    desc: 'Nuovi film e serie TV pubblicati sul Server Elite',
    dot: 'bg-blue-500',
    ring: 'from-blue-500/30 to-transparent',
    border: 'border-blue-500/40',
    icon: Sparkles,
    accent: 'text-blue-400',
  },
];

export default function Novita() {
  useEffect(() => {
    localStorage.setItem('gtc_last_novita_seen', new Date().toISOString());
  }, []);

  return (
    <Layout title="Novità Contenuti" showBack backTo="/home">
      <div className="px-5 pt-6 max-w-md mx-auto space-y-4">
        <p className="text-sm text-white/60 leading-relaxed">
          Scegli il server per vedere gli ultimi film e serie TV aggiunti.
        </p>

        {CATEGORIES.map((c, i) => (
          <motion.div
            key={c.id}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * i, duration: 0.35 }}
          >
            <Link
              to={`/novita/${c.id}`}
              data-testid={`novita-server-${c.id}`}
              className={`card-surface p-5 flex items-center gap-4 block relative overflow-hidden ${c.border}`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${c.ring} opacity-60 pointer-events-none`} />
              <div className={`relative w-3 h-3 rounded-full ${c.dot} shrink-0`} />
              <div className={`relative w-14 h-14 rounded-2xl bg-[var(--bg-elevated)] border ${c.border} flex items-center justify-center`}>
                <c.icon className={`w-6 h-6 ${c.accent}`} strokeWidth={1.7} />
              </div>
              <div className="relative flex-1 min-w-0">
                <div className="font-heading text-base font-medium text-white">{c.name}</div>
                <div className="text-xs text-white/60 mt-0.5">{c.desc}</div>
              </div>
              <ChevronRight className="relative w-5 h-5 text-white/40" />
            </Link>
          </motion.div>
        ))}
      </div>
    </Layout>
  );
}
